// extracted by mini-css-extract-plugin
module.exports = {"Column":"styles_Column__WwCPm","Collapsed":"styles_Collapsed__1wU_R","SwitchButton":"styles_SwitchButton___xe2q","ButtonExpanded":"styles_ButtonExpanded__3ocPV"};